

































































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { listColumns, userColumns, poolColumns, filterColumns } from '../config/index'
import {
  queryGroupList,
  queryGroupItem,
  queryUsers,
  deleteUser,
  addUsers,
  queryPermList,
  changePerms,
  queryAllUserList,
  queryAllUsers
} from '../../../service/settings'

@Component
export default class PermissionManage extends Vue {
  selectedRowKeys: any[] = []
  checkedList: any[] = []
  onSelectChange(selectedRowKeys, selectedRows) {
    this.selectedRowKeys = selectedRowKeys
    this.alternativeUserIds = selectedRows.map((item) => item.id)
  }
  getCheckboxProps(record) {
    return {
      props: {
        defaultChecked: record.checked
      }
    }
  }
  isListVisible: boolean = true
  isDetialsVisible: boolean = false
  isPoolVisible: boolean = false
  groupInfo = {
    count: 0,
    id: '',
    name: ''
  }
  listColumns = listColumns
  userColumns = userColumns
  poolColumns = poolColumns
  filterColumns = filterColumns
  dataSource: any[] = []
  userDataSource: any[] = []
  poolDataSource: any[] = []
  filterDataSource: any[] = [] // 权限列表
  apiValue: string = ''
  poolValue: string = ''
  value = ''
  data = []
  alternativeUserIds: string[] = []
  userPagination = {
    total: 0,
    current: 1,
    showTotal: (total) => `共 ${total} 条`
  }
  handleUserTableChange(pagination, filters, sorter) {
    this.renderUserList(pagination.current)
  }
  filterPagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showTotal: (total) => `共 ${total} 条`
  }
  handleFilterTableChange(pagination, filters, sorter) {
    this.renderPermList(pagination.current)
  }
  handlePoolTableChange(pagination, filters, sorter) {
    this.renderAllUserList(pagination.current)
  }
  tagsValue = []
  public currentTagId: string = ''
  public currentTagList: any[] = []
  public async onTagsChange(item, index, record) {
    const beforeValue = item.checked
    this.filterDataSource[record.key].tags[index].checked = !beforeValue
    if (!beforeValue) {
      this.filterDataSource[record.key].checked = true
    }
    await this.handleChangePerms(record)
  }

  public async onFilterItemChange(record) {
    const beforeValue = record.checked
    this.filterDataSource[record.key].checked = !beforeValue
    await this.handleChangePerms(record)
  }

  public async handleChangePerms(record) {
    const tags = record.tags.filter((item) => item.checked).map((item) => item.role_id)
    const options = {
      tags,
      req_id: record.id,
      group_id: this.groupInfo.id,
      is_selected: this.filterDataSource[record.key].checked ? '1' : '0'
    }
    await changePerms(options)
  }

  public async mounted() {
    const ret = await queryGroupList()
    this.dataSource = ret
  }
  public async handleListItemClick(id) {
    this.isListVisible = false
    this.isDetialsVisible = true
    this.groupInfo = await queryGroupItem(id)
    this.renderUserList(1)
    this.renderPermList(1)
  }
  public async renderPermList(page) {
    const options = {
      search: this.apiValue,
      filter: String(this.radioValue),
      group_id: this.groupInfo.id,
      page,
      page_size: this.filterPagination.pageSize
    }
    this.filterDataSource = []
    const { list, total } = await queryPermList(options)
    this.filterDataSource = list
    this.filterPagination.total = total
    this.filterPagination.current = page
  }
  public async renderUserList(current: number) {
    const groupId = this.groupInfo.id
    if (groupId) {
      const { list, total } = await queryUsers(groupId, current)
      this.userDataSource = list
      this.userPagination.total = total
      this.userPagination.current = current
    }
  }
  public handleDeleteUser(key, userId) {
    const userDataSource = [...this.userDataSource]
    this.userDataSource = userDataSource.filter((item) => item.key !== key)
    const { id } = this.groupInfo
    if (id) {
      deleteUser(id, userId)
    }
    if (this.groupInfo && this.groupInfo.count) {
      this.groupInfo.count--
    }
  }
  public onSearch(value) {
    this.renderAllUserList(1)
  }
  public onAPISearch(value) {
    this.renderPermList(1)
  }
  public async addMoreUsers() {
    this.isDetialsVisible = false
    this.isPoolVisible = true
    await this.renderAllUserList(1)
  }
  public backToUserList() {
    this.isDetialsVisible = true
    this.isPoolVisible = false
  }
  public async renderAllUserList(page: number) {
    this.poolDataSource = []
    this.selectedRowKeys = []
    this.alternativeUserIds = []
    const options = {
      name: this.poolValue,
      group_id: String(this.groupInfo.id)
    }
    const { list, total } = await queryAllUsers(options)
    this.poolDataSource = list
    list.map((item: any, index: number) => {
      if (item.checked) {
        this.selectedRowKeys.push(item.key)
        this.alternativeUserIds.push(item.id)
      }
    })
  }
  public async submitUsers() {
    const groupId = this.groupInfo.id
    let userIds = [...this.alternativeUserIds].join(',')
    if (groupId) {
      const { success } = await addUsers(groupId, this.alternativeUserIds)
      if (success) {
        this.isDetialsVisible = true
        this.isPoolVisible = false
        await this.renderUserList(1)
        this.groupInfo = await queryGroupItem(groupId)
      } else {
        return
      }
    }
  }

  public radioValue = 0
  public onRadioChange(e) {
    this.renderPermList(1)
  }
  public backToMainList(e) {
    this.isListVisible = true
    this.isDetialsVisible = false
    this.radioValue = 0
    this.apiValue = ''
    this.filterDataSource = []
  }
}
